import dayjs from "dayjs";

import { RejectDropValue } from "@/types/job";

import { COLORS } from "@/constants/jobs";

export const formatDate = (date: string) => dayjs(date).format("DD MMM YYYY");

export const formatBackendKey = (key: string) => {
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatWeek = (week: string) => {
  const match = week.match(/Week (\d+) \((.+) to (.+)\)/);
  if (match) {
    const weekNum = match[1];
    const start = dayjs(match[2]).format("DD MMM");
    const end = dayjs(match[3]).format("DD MMM");
    return `Week ${weekNum}\n(${start} - ${end})`;
  }
  return week;
};

export const formatCell = (value?: RejectDropValue) => {
  if (!value) return "0 | 0";

  const rejected = value.rejected === "-" ? "-" : value.rejected;
  const dropped = value.dropped === "-" ? "-" : value.dropped;

  return `${rejected} | ${dropped}`;
};

export const colorForKey = (key: string) => {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
};

export const labelForKey = (key: string) => {
  if (/^\d+$/.test(key)) return `Round ${key}`;
  return key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};
